var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    transform: "translate(-11130 21983)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_263",
    "data-name": "Ellipse 263",
    cx: 125,
    cy: 125,
    r: 125,
    transform: "translate(11130 -21983)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907",
    transform: "translate(10319.396 -22144.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M894.8,212.008a34.436,34.436,0,0,0-.7,39.338s-26.515-6.678-23.289-18.678,11.787-8.659,12.768-10.762S884,207.678,894.8,212.008Z",
    transform: "translate(105.062 7.802)",
    fill: "#e2e5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M862.8,222.394s-32.816,23.368-6.152,59.2c0,0-25.295-.633-30.309-13.395s-.685-22.788,6.607-26.206,8.154-6.723,10.542-11.352S854.592,218.064,862.8,222.394Z",
    transform: "translate(9.674 28.508)",
    fill: "#e2e5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M880.873,279.4a37.123,37.123,0,0,1-12.8-67.164,37.125,37.125,0,1,0,32.147,66.143A36.882,36.882,0,0,1,880.873,279.4Z",
    transform: "translate(47.225 10.178)",
    fill: "#e2e5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M942.546,260.656H844.44a3.057,3.057,0,1,1,0-6.115h98.106a3.057,3.057,0,1,1,0,6.115Z",
    transform: "translate(45.084 97.221)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M871.583,260.656H822.529a3.057,3.057,0,1,1,0-6.115h49.054a3.057,3.057,0,1,1,0,6.115Z",
    transform: "translate(0 97.221)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M932.4,260.656H883.351a3.057,3.057,0,1,1,0-6.115H932.4a3.057,3.057,0,1,1,0,6.115Z",
    transform: "translate(125.142 97.221)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M916.479,287.384H848.367a25.679,25.679,0,0,1-6.8-50.443,21,21,0,0,1,31.991-13.789l-3.3,5.143a14.886,14.886,0,0,0-22.891,11.389l-.184,2.354-2.321.419a19.564,19.564,0,0,0,3.507,38.812h68.112Z",
    transform: "translate(6.605 25.774)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M930.835,260.013h-43.8a17.6,17.6,0,0,1-5.3-34.391,14.689,14.689,0,0,1,14.211-11.239,14.534,14.534,0,0,1,5.225.972,21.264,21.264,0,0,1,37.867,11.487,17.6,17.6,0,0,1-8.2,33.171ZM895.946,220.5a8.528,8.528,0,0,0-8.466,7.836l-.183,2.351-2.318.422a11.488,11.488,0,0,0,2.058,22.791h43.8a11.486,11.486,0,0,0,4.1-22.216l-2.036-.78.095-2.428a15.156,15.156,0,0,0-28.2-7.638l-1.618,2.718-2.66-1.709A8.475,8.475,0,0,0,895.946,220.5Z",
    transform: "translate(102.793 0)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M954.477,308.453l-39.2-35.972a40.427,40.427,0,1,0-11.417,11.759l35.81,39.02a10.389,10.389,0,0,0,7.494,3.391c.079,0,.156,0,.232,0a10.481,10.481,0,0,0,7.078-18.2ZM874.1,284.324a34.1,34.1,0,0,1,7.133-67.424,34.148,34.148,0,0,1,33.388,41.3,34.091,34.091,0,0,1-40.521,26.12Zm76.38,34.938a4.5,4.5,0,0,1-3.18,1.275,4.312,4.312,0,0,1-3.119-1.41L909.2,281.009l3.027-3.03,38.121,34.978a4.374,4.374,0,0,1,.135,6.3Z",
    transform: "translate(44.479 7.215)",
    fill: "#2f4265"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/noResults.739549b47416177c6fc0995b24e1ea7a.svg";
export { ForwardRef as ReactComponent };